<template>
    <v-card class="pa-3 ma-md-3">
        <template v-if="!showFilters">
            <v-toolbar flat color="#1d2735" dark>
                <v-icon class="white--text" style="font-size: 45px"
                    >mdi-account-supervisor-circle</v-icon
                >
                <pre><v-toolbar-title><h2>Lista de pedidos</h2></v-toolbar-title></pre>
            </v-toolbar>
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        :to="{ path: `/guardar-pedido-proveedor` }"
                        :loading="isloading"
                        :disabled="isloading"
                        color="success"
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text">mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Nuevo pedido</span>
            </v-tooltip>

            <v-row>
                <v-col cols="12" md="3">
                    <proveedoresSelectVue
                        label="Proveedor"
                        v-model="id_proveedor"
                        item-text="nombre"
                        item-value="id"
                    ></proveedoresSelectVue>
                </v-col>
                <v-col cols="12" md="2">
                    <ordenesSelect
                        label="Obra"
                        v-model="id_orden"
                    ></ordenesSelect>
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete
                        label="Pendiente albarán"
                        v-model="pdt_albaran"
                        :items="[
                            { value: 1, text: 'Pendiente' },
                            { value: 0, text: 'Creado' },
                        ]"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete
                        label="Estado"
                        v-model="estado"
                        :items="estados"
                        item-text="nombre"
                        item-value="id"
                        multiple
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2">
                    <div class="d-flex justify-space-between">
                        <v-btn
                            color="red"
                            style="color: white"
                            @click="
                                () => {
                                    id_proveedor = null;
                                    id_orden = null;
                                    pdt_albaran = null;
                                    getPedidos();
                                }
                            "
                            >Limpiar</v-btn
                        >
                        <v-btn
                            class="ml-2"
                            color="success"
                            @click="ExportExcel"
                        >
                            <v-icon class="white--text">mdi-file-excel</v-icon>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field
                        prepend-icon="mdi-account-search"
                        v-model="search"
                        label="Buscar"
                    ></v-text-field>
                </v-col>
            </v-row>
        </template>
        <v-data-table
            dense
            :headers="headers"
            :items="Pedidos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            :item-class="getRowClass"
            class="elevation-1"
            @update:sort-by="
                (val) => {
                    sortby = val;
                }
            "
            @update:sort-desc="
                (val) => {
                    sortdesc = val;
                }
            "
            @click:row="
                (item) => {
                    OpenOrdenInNextWindow(item);
                }
            "
            :server-items-length="total_pedidos"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <!-- proveedor -->
            <!-- <template v-slot:item.id_proveedor="{ item }">
                <span v-if="item.proveedor != null">{{
                    item.proveedor.nombre
                }}</span>
            </template> -->
            <!-- referencia -->
            <!-- <template v-slot:item.id_orden="{ item }">
                <span v-if="item.orden != null">{{
                    item.orden.nro_orden
                }}</span>
            </template> -->
            <template v-slot:item.fecha_real="{ item }">
                <span v-if="item.fecha_real != null">{{
                    item.fecha_real | format_date
                }}</span>
            </template>
            <template v-slot:item.fecha_pedido="{ item }">
                <span v-if="item.fecha_pedido != null">{{
                    item.fecha_pedido | format_date
                }}</span>
            </template>
            <template v-slot:item.fecha_prevista="{ item }">
                <span v-if="item.fecha_prevista != null">{{
                    item.fecha_prevista | format_date
                }}</span>
            </template>
            <template v-slot:item.total="{ item }">
                <span v-if="item.total != null">{{
                    item.total | format_precio
                }}</span>
            </template>
            <template v-slot:item.pdf="{ item }">
                <a :href="`api/pdf-pedido-proveedor/${item.id}`">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>

            <template v-slot:item.pdt_albaran="{ item }">
                <v-chip
                    :color="
                        item.pdt_albaran == 0 || item.pdt_albaran == null
                            ? 'green'
                            : ''
                    "
                    size="small"
                >
                    {{
                        item.pdt_albaran == 0 || item.pdt_albaran == null
                            ? "Creado"
                            : "Pendiente"
                    }}
                </v-chip>
            </template>

            <template v-slot:item.action="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            @click.stop="openModal(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon
                                small
                                class="mr-2"
                                color="red"
                                style="pointer-events: none; font-size: 25px"
                                title="BORRAR"
                                >mdi-trash-can</v-icon
                            >
                        </a>
                    </template>
                    <span>Borrar</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            @click.stop="openModalRecepcionar(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon
                                small
                                class="mr-2"
                                color="green"
                                style="pointer-events: none; font-size: 25px"
                                title="RECEPCIONAR"
                                >mdi-file-check-outline</v-icon
                            >
                        </a>
                    </template>
                    <span>Recepcionar</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <a @click.stop="() => {}" v-bind="attrs" v-on="on">
                            <router-link
                                :to="{
                                    path: `/guardar-pedido-proveedor?id=${
                                        item.id
                                    }&duplicate=${true}`,
                                }"
                                class="action-buttons"
                            >
                                <v-icon
                                    small
                                    class="mr-2"
                                    style="
                                        pointer-events: none;
                                        font-size: 25px;
                                    "
                                    title="DUPLICAR"
                                >
                                    mdi-content-duplicate
                                </v-icon>
                            </router-link>
                        </a>
                    </template>
                    <span>Duplicar</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            @click.stop="reclamar(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon
                                small
                                class="mr-2"
                                color="red"
                                style="pointer-events: none; font-size: 25px"
                                title="RECLAMAR"
                                >mdi-file-alert-outline</v-icon
                            >
                        </a>
                    </template>
                    <span>Reclamar</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            @click.stop="openModalAlbaran(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon
                                small
                                class="mr-2"
                                color="red"
                                style="font-size: 25px"
                                title="ALBARANES"
                                >mdi-truck-delivery</v-icon
                            >
                        </a>
                    </template>
                    <span>Albaranes</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="recepcionar" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text class="mt-4" style="text-align: center">
                    <h2
                        v-if="
                            this.selectedItem
                                ? this.Pedidos[this.selectedItem].estado !=
                                  'Recepcionado'
                                : false
                        "
                    >
                        ¿Desea recepcionar el pedido?
                    </h2>
                    <h2 v-else>¿Desea devolver el estado a pedido?</h2>
                    <p class="w-100">
                        <v-switch
                            v-model="pendiente_albaran"
                            class="m-auto"
                            label="Pendiente albarán"
                            hide-details
                            inset
                        ></v-switch>
                    </p>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            recepcionar = false;
                            selectedItem = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="recepcionarPedido()"
                        >Aceptar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <ConfimDialog
            v-model="confirm_albaran"
            title="Confirmar albarán"
            message="Confirmar creación de albarán"
            @confirm="saveAlbaran"
        ></ConfimDialog>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";

import ConfimDialog from "../../albaranes/componentes/ConfimDialog.vue";
import proveedoresSelectVue from "../../../components/general/proveedoresSelect.vue";
import ordenesSelect from "../../../components/general/ordenesSelect.vue";
export default {
    props: ["id_orden_ext", "showFilters"],

    components: { proveedoresSelectVue, ordenesSelect, ConfimDialog },
    watch: {
        id_orden_ext(val) {
            this.id_orden = val;

            this.getPedidos();
        },
        sortby(val) {
            console.log(val);
            this.getPedidos();
        },
        sortdesc: debounce(function (val) {
            console.log(val);
            this.getPedidos();
        }, 500),
        id_proveedor: debounce(function (val) {
            this.getPedidos();
        }, 500),
        pdt_albaran: debounce(function (val) {
            this.getPedidos();
        }, 500),
        id_orden: debounce(function (val) {
            this.getPedidos();
        }, 500),
        pd: debounce(function (val) {
            this.getPedidos();
        }, 500),
        search: debounce(function (val) {
            this.getPedidos();
        }, 500),
        estado: debounce(function (val) {
            this.getPedidos();
        }, 500),
    },
    data() {
        return {
            total_pedidos: 0,
            sortdesc: null,
            sortby: null,
            pedido: null,
            confirm_albaran: false,
            proveedores: [],
            id_proveedor: null,
            id_orden: null,
            ordenes: [],
            search: "",
            headers: [
                { text: "Pedido", value: "id", sortable: true },
                {
                    text: "Proveedor",
                    value: "proveedor",
                    sortable: true,
                },
                {
                    text: "Fecha del pedido",
                    value: "fecha_pedido",
                    sortable: true,
                },
                {
                    text: "Referencia",
                    value: "nro_orden",
                    sortable: true,
                },
                {
                    text: "F. Prev. Servicio",
                    value: "fecha_prevista",
                    sortable: true,
                },
                { text: "Descripción", value: "descripcion" },
                {
                    text: "Fecha real de recepción",
                    value: "fecha_real",
                    sortable: true,
                },
                { text: "Estado", value: "estado", sortable: false },
                { text: "Albarán", value: "pdt_albaran", sortable: true },
                { text: "Costo", value: "total", sortable: false },
                { text: "PDF", value: "pdf" },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Pedidos: [],
            selectedItem: 0,
            dialog: false,
            pdt_albaran: null,
            estado: null,
            estados: [],
            recepcionar: false,
            cantidad: 15,
            pendiente_albaran: 0,
            page: 1,
        };
    },
    created() {
        if (this.id_orden_ext) {
            this.id_orden = this.id_orden_ext;

            this.getPedidos();
        }
        this.getPedidos();
        this.getEstados();
    },
    methods: {
        getEstados() {
            axios.get("api/get-estados-proveedor-pedido").then((res) => {
                this.estados = res.data;
            });
        },
        OpenOrdenInNextWindow(item) {
            //this.$router.push(`/guardar-pedido-proveedor?id=${item.id}`);
            window.open(`/#/guardar-pedido-proveedor?id=${item.id}`, "_blank");
        },
        openModalAlbaran(item) {
            this.confirm_albaran = true;
            this.pedido = item;
        },
        saveAlbaran() {
            let lineas = [];
            this.pedido.lineas.forEach((linea) => {
                lineas.push({
                    id_pedido: this.pedido.id,
                    id_pedido_linea: linea.id,
                    id_iva: linea?.producto?.id_iva,
                    cantidad: linea.cantidad,
                    dcto: linea.dcto,
                    descripcion: linea.descripcion,
                    id_producto_compra: linea.id_producto_compra,
                    precio: linea.precio,
                    total: linea.precio * linea.cantidad - linea.dcto,
                });
            });
            let albaran = {
                id_proveedor: this.pedido.id_proveedor,
                importe: this.pedido.total,
                observaciones: this.pedido.observaciones,
                lineas: lineas,
                id_pedido: this.pedido.id,
            };
            axios
                .post("api/save-albaran", albaran)
                .then((res) => {
                    this.$router.push("lista-albaranes");
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.code == 400) {
                        this.$custom_error(error.response.data.error);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        ChangeSize(event) {
            this.cantidad = event;
            this.getPedidos();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getPedidos();
        },
        getRowClass(item) {
            if (item.reclamar == 1) {
                return "yellow pointer";
            }

            return "pointer";
        },
        getPedidos() {
            const str = this.filterStr;
            axios
                .get(`api/get-pedidos-proveedor`, {
                    params: {
                        page: this.page,
                        amount: this.cantidad,
                        id: 0,
                        sortby: this.sortby,
                        sortdesc: this.sortdesc,
                        search: this.search,
                        id_orden: this.id_orden,
                        id_proveedor: this.id_proveedor,
                        pdt_albaran: this.pdt_albaran,
                        estado: this.estado,
                    },
                })
                .then(
                    (res) => {
                        this.Pedidos = res.data.data;
                        this.total_pedidos = res.data.meta.total;
                    },
                    (err) => {
                        this.$custom_error("Error consultando los pedidos");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.Pedidos.indexOf(item);
            this.dialog = true;
        },
        openModalRecepcionar(item) {
            this.selectedItem = this.Pedidos.indexOf(item);
            this.pendiente_albaran = item.pdt_albaran;
            this.recepcionar = true;
        },
        deleteUser() {
            axios
                .get(
                    `api/delete-pedido-proveedor/${
                        this.Pedidos[this.selectedItem].id
                    }`
                )
                .then(
                    (res) => {
                        this.$toast.sucs("Pedido eliminado con éxito");
                        this.dialog = false;
                        this.getPedidos();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el pedido");
                    }
                );
        },
        recepcionarPedido() {
            axios
                .get(
                    `api/recepcionar-pedido-proveedor/${
                        this.Pedidos[this.selectedItem].id
                    }?pdt_albaran=${this.pendiente_albaran ? 1 : 0}`
                )
                .then(
                    (res) => {
                        this.$toast.sucs("Pedido recepcionado con éxito");
                        this.recepcionar = false;
                        this.getPedidos();
                    },
                    (err) => {
                        this.$custom_error("Error recepcionando el pedido");
                    }
                );
        },
        reclamar(item) {
            this.selectedItem = this.Pedidos.indexOf(item);

            axios
                .get(
                    `api/reclamar-pedido-proveedor/${
                        this.Pedidos[this.selectedItem].id
                    }`
                )
                .then(
                    (res) => {
                        this.$toast.sucs(res.data.success);
                        // this.recepcionar = false;
                        this.getPedidos();
                    },
                    (err) => {
                        this.$custom_error(res.data.error);
                    }
                );
        },

        ExportExcel() {
            axios
                .get(`/api/excel-proveedor-pedido`, {
                    params: {
                        page: this.page,
                        // amount: this.cantidad,
                        amount: -1,
                        id: 0,
                        sortby: this.sortby,
                        sortdesc: this.sortdesc,
                        search: this.search,
                        id_orden: this.id_orden,
                        id_proveedor: this.id_proveedor,
                        pdt_albaran: this.pdt_albaran,
                        estado: this.estado,
                    },
                    responseType: "blob",
                })
                .then((response) => {
                    console.log("res", response);
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "proveedor_pedido.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    console.error("Error exporting clientes:", error);
                });
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
        filterStr: function () {
            let str = "";
            if (this.pdt_albaran != null) {
                str += `&pdt_albaran=${this.pdt_albaran}`;
            }
            if (this.id_proveedor != null) {
                str += `&id_proveedor=${this.id_proveedor}`;
            }
            if (this.id_orden != null) {
                str += `&id_orden=${this.id_orden}`;
            }
            if (this.search != null) {
                str += `&search=${this.search}`;
            }
            if (this.pdt_albaran != null) {
                str += `&pdt_albaran=${this.pdt_albaran}`;
            }

            return str;
        },
    },
};
</script>
